import { Flex } from '@chakra-ui/react';
import { OnChangeValue } from 'chakra-react-select';

import { selectValueToArray } from '../../combobox';
import {
  AvatarOption,
  AvatarOptionVariant,
  defaultProps,
  EditableAvatar,
} from '../../editable/editable-avatar';
import {
  EditableMultiSelectAvatar,
  GroupedAvatars,
} from '../../editable/editable-multiselect-avatar';
import { createSelectHelper } from '../shared/select';

type AvatarExtraColumnDef = {
  variant?: AvatarOptionVariant;
  groupSize?: number;
};

export function AvatarPreview({
  value,
  variant = 'short',
  groupSize = 2,
  isMulti,
}: {
  value?: OnChangeValue<AvatarOption, boolean>;
  variant?: AvatarOptionVariant;
  groupSize?: number;
  isMulti?: boolean;
}) {
  const values = selectValueToArray(value);

  return (
    <Flex p={2} flexGrow="1" height="full">
      <GroupedAvatars
        values={values}
        groupSize={groupSize}
        size="sm"
        variant={isMulti ? 'short' : variant}
      >
        {values.map((data) => (
          <EditableMultiSelectAvatar.Option key={data.id} size="sm" {...data} />
        ))}
      </GroupedAvatars>
    </Flex>
  );
}

export const avatar = createSelectHelper<AvatarOption, AvatarExtraColumnDef>({
  columnType: 'avatar',
  getOptionValue: defaultProps.getOptionValue,
  getOptionLabel: defaultProps.getOptionLabel,

  components: {
    Preview: ({ columnDef: { variant = 'short', groupSize = 2, isMulti }, value }) => (
      <AvatarPreview value={value} variant={variant} groupSize={groupSize} isMulti={isMulti} />
    ),

    Edit: EditableAvatar,
  },
});
